import { FavouriteDefinition, Value } from 'app/types-shared';
import { updateSelectedReport } from './selected-report';

export const updateAggregation = (
  definition: FavouriteDefinition,
  aggregationDomain: Value,
  aggregationType: Value,
  uomSetDomain: Value
): FavouriteDefinition => {

  const updatedReportFields = !!aggregationDomain?.v 
    ? {
      aggregationDomain,
      aggregationType,
      uomSetDomain
    }
    : {
      aggregationDomain: undefined,
      aggregationType: undefined,
      uomSetDomain: undefined
    };

    return updateSelectedReport(definition, updatedReportFields);
};
